import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Layout from "../../components/global/layout";
import "./style.scss";
import AllChart from "../../components/common/AllChart";
import { useHistory } from "react-router-dom";
import methodModel from "../../methods/methods";
import DateRangePicker from "../../components/common/DateRangePicker";
import datepipeModel from "../../models/datepipemodel";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import Chart from "react-google-charts";
import BarChart from "../../components/common/BarChart";
import moment from "moment";
import Layout2 from "../../components/global/layout2";
import { Tooltip } from "antd";
import FleetOverview from "../../components/common/FleetOverview";
import FinancialMetrics from "../../components/common/DashboardWidgets/FinancialMetrics";
import PerformanceMetrics from "../../components/common/DashboardWidgets/PerformanceMetrics";
import GrowthMetrics from "../../components/common/DashboardWidgets/GrowthMetrics";
import TodayOperations from "../../components/common/DashboardWidgets/TodayOperations";

const Dashboard2 = () => {
  const Navigate = useHistory();
  const user = useSelector((state) => state.user);
  let current = datepipeModel.datetostring(new Date());
  const [DileveryOutside, SetDileveryOutside] = useState([]);
  const [PeakPostingHour, setPeakPostingHour] = useState([]);
  const [PeakPostingMonths, setPeakPostingMonths] = useState([]);
  const [Filtername, setFIltername] = useState("");
  const [MostInbound, setMostInbound] = useState([]);
  // const [StatisticsData, setStatistics] = useState([]);
  const [LoadsData, setLoadData] = useState({});
  let startDate = `${current.split("-")[0]}-${current.split("-")[1]}-01`;
  console.log(startDate, "startDate")
  const [destinations, setdestination] = useState([]);
  const [DileveyHour, setDileveyHour] = useState([]);
  const [PeakPickupDays, setPeakPickDay] = useState([]);
  // const [Awarded, SetAwarded] = useState(0);
  const [MostBound, setMostBound] = useState([]);
  const [maxDistance, setMaxdistance] = useState([]);
  const [StopTotalTime, setStopTotalTime] = useState([]);
  const [PickUpHours, setPickUpHours] = useState([]);
  // const [AverageCost, setAverageCost] = useState([]);
  let month2 = new Date(
    new Date().getFullYear(),
    new Date().getMonth() + 1,
    0
  );
  let endDate = datepipeModel.datetostring(month2);
  console.log(endDate, "endDate")
  const [origins, setorigins] = useState([]);
  const [filters, setFilter] = useState({
    startDate: startDate,
    endDate: endDate,
    compare: "",
    compareStart: "",
    compareEnd: "",
    type: "monthly",
  });
  console.log(filters, "filters")
  const [bidChart, setBidChart] = useState([]);
  const [loadChart, setLoadChart] = useState([]);
  const [boards, setBoards] = useState([]);
  const [Frequency, setFrequency] = useState({});
  const [ChartData, setData] = useState([]);
  const [Board, setBoard] = useState([]);
  const [cartData, setChartData] = useState({
    totalBids: 0,
    totalLoads: 0,
  });
  const Permission = JSON.parse(localStorage.getItem("permission"));
  const GetBoards = () => {
    ApiClient.get("boards?status=active").then((res) => {
      if (res.success) {
        setBoard(res?.data?.data);
      }
    });
  };
  // const GetAwardedBids = (p) => {
  //   let f = { ...filters, ...p };
  //   if (p?.board_id) {
  //     f = { ...filters, board_id: p?.board_id };
  //   }
  //   ApiClient.get("bids?status=awarded", f).then((res) => {
  //     if (res.success) {
  //       SetAwarded(res?.data?.total);
  //     }
  //   });
  // };

  const GetAnalytics = (p) => {
    let f = { ...filters, ...p };
    if (p?.board_id) {
      f = { ...filters, board_id: p?.board_id };
    }

    ApiClient.get("total-loads", f).then((res) => {
      if (res.success) {
        setLoadData(res);
      }
    });
  };

  // const options = {
  //   title: "Loads from diffrent Location",
  //   chartArea: { width: "50%" },
  //   colors: ["#b0120a", "#ffab91"],
  //   hAxis: {
  //     title: "Total Loads",
  //     minValue: 0,
  //   },
  //   vAxis: {
  //     title: "Loads",
  //   },
  // };
  // let ChartData = [["Loads", "2010 Population", "2000 Population"]];
  const GetFrequency = (p) => {
    let array = [];
    let f = { ...filters, ...p };
    if (p?.board_id) {
      f = { ...filters, board_id: p?.board_id };
    }


    ApiClient.get("admin/dashboard/lane-frequency", f).then((res) => {
      if (res.success) {
        // setFrequency(res?.data);
        let croped = res?.data?.splice(0, 8);
        croped?.map((itm) => {
          array.push({
            totalLoad: itm?.count,
            address: itm?.origin_address,
            date: `${itm?.origin_address} - ${itm?.destination_address}`,
          });
        });
      }

      setData(array);
    });
  };

  const BidsByChartData = [
    ["Location", "Total Loads"],
    ...((ChartData?.length > 0 &&
      ChartData?.map((item) => {
        return [`${item?.date}`, item?.totalLoad];
      })) || [
        ["Element", "Density", { role: "style" }],
        ["Copper", 8.94, "#b87333"], // RGB value
        ["Silver", 10.49, "silver"], // English color name
        ["Gold", 19.3, "gold"],
        ["Platinum", 21.45, "color: #e5e4e2"], // CSS-style declaration
      ]),
  ];
  const GetOrigins = (p) => {
    let array = [];
    let f = { ...filters, ...p };
    if (p?.board_id) {
      f = { ...filters, board_id: p?.board_id };
    }
    ApiClient.get("admin/dashboard/orgin-volume", f).then((res) => {
      if (res.success) {
        // setFrequency(res?.data);
        let croped = res?.data?.splice(0, 8);
        croped?.map((itm) => {
          array.push({
            totalLoad: itm?.count,
            address: itm?.origin_address,
            date: itm?.origin_address,
          });
        });
      }

      setorigins(array);
    });
  };
  // const GetAverage = [
  //   ["Origin Address", "Total", "Avg Cost ($)"],
  //   ...((AverageCost?.length > 0 &&
  //     AverageCost?.map((item) => {
  //       return [
  //         `${item?.address}`,
  //         item?.totalLoad,
  //         Math.round(item?.avg_cost),
  //       ];
  //     })) || [
  //       ["Element", "Density", { role: "style" }],
  //       ["Copper", 8.94, "#b87333"], // RGB value
  //       ["Silver", 10.49, "silver"], // English color name
  //       ["Gold", 19.3, "gold"],
  //       ["Platinum", 21.45, "color: #e5e4e2"], // CSS-style declaration
  //     ]),
  // ];


  // const GetAverageCost = (p) => {
  //   let array = [];
  //   let f = { ...filters, ...p };
  //   if (p?.board_id) {
  //     f = { ...filters, board_id: p?.board_id };
  //   }

  //   ApiClient.get("admin/dashboard/lane-frequency/cost-analysis").then(
  //     (res) => {
  //       if (res.success) {
  //         // setFrequency(res?.data);
  //         let croped = res?.data?.splice(0, 8);
  //         croped?.map((itm) => {
  //           array.push({
  //             totalLoad: itm?.count,
  //             address: itm?.origin_address,
  //             avg_cost: itm?.avg_cost,
  //           });
  //         });
  //       }

  //       setAverageCost(array);
  //     }
  //   );
  // };

  const StopsTotalTimes = [
    ["Origin Address", "Total", "Avg. Cost ($)", "Time"],
    ...((StopTotalTime?.length > 0 &&
      StopTotalTime?.map((item) => {
        return [
          `${item?.address}`,
          item?.totalLoad,
          Math.round(item?.avg_cost),
          item?.total_time,
        ];
      })) || [
        ["Element", "Density", { role: "style" }],
        ["Copper", 8.94, "#b87333"], // RGB value
        ["Silver", 10.49, "silver"], // English color name
        ["Gold", 19.3, "gold"],
        ["Platinum", 21.45, "color: #e5e4e2"], // CSS-style declaration
      ]),
  ];

  const GetStopTotalTimes = (p) => {
    let f = { ...filters, ...p };
    if (p?.board_id) {
      f = { ...filters, board_id: p?.board_id };
    }

    let array = [];
    ApiClient.get("admin/dashboard/lane-frequency/stop-totaltime", f).then(
      (res) => {

        if (res.code == 200) {
          // setFrequency(res?.data);
          let croped = res?.data?.splice(0, 8);
          croped?.map((itm) => {
            array.push({
              address: itm?.origin_address,
              totalLoad: itm?.count,
              avg_cost: itm?.avg_stop_parload,
              total_time: itm?.total_time,
            });
          });
        }

        setStopTotalTime(array);
      }
    );
  };

  const DileveyHours = [
    ["Location", "Total Loads"],
    ...((DileveyHour?.length > 0 &&
      DileveyHour?.map((item) => {
        return [
          `${item?.address} delivered at ${moment(item?.delivered_at).format(
            "DD-MM-YYYY HH:MM A"
          )}`,
          item?.totalLoad,
        ];
      })) ||
      [
        ["Element", "Density", { role: "style" }],
        ["Copper", 8.94, "#b87333"], // RGB value
        ["Silver", 10.49, "silver"], // English color name
        ["Gold", 19.3, "gold"],
        ["Platinum", 21.45, "color: #e5e4e2"], // CSS-style declaration
      ]
    ),
  ];

  const GetDelveryHours = (p) => {
    let array = [];
    let f = { ...filters, ...p };
    if (p?.board_id) {
      f = { ...filters, board_id: p?.board_id };
    }
    ApiClient.get("admin/dashboard/peak-delvery-hours", f).then((res) => {

      if (res.code == 200) {
        // setFrequency(res?.data);
        let croped = res?.data?.splice(0, 8);
        croped?.map((itm) => {
          array.push({
            address: itm?.origin_address,
            totalLoad: itm?.count,
            delivered_at: itm?.delivered_at,
            // destination_address: itm?.destination_address,
          });
        });
      }
      setDileveyHour(array);
    });
  };


  const GetOirignBids = [
    ["Origin", "Total Loads"],
    ...((origins?.length > 0 &&
      origins?.map((item) => {
        return [`${item?.date} `, item?.totalLoad];
      })) || [
        ["Element", "Density", { role: "style" }],
        ["Copper", 8.94, "#b87333"], // RGB value
        ["Silver", 10.49, "silver"], // English color name
        ["Gold", 19.3, "gold"],
        ["Platinum", 21.45, "color: #e5e4e2"], // CSS-style declaration
      ]),
  ];
  const MaxInbound = (p) => {
    let array = [];

    let array1 = [];
    let f = { ...filters, ...p };
    if (p?.board_id) {
      f = { ...filters, board_id: p?.board_id };
    }

    ApiClient.get("admin/dashboard/orgin-volume", f).then((res) => {
      if (res.success) {
        ApiClient.get("admin/dashboard/destination-volume").then((resp) => {
          if (resp.success) {
            let croped = res?.data?.splice(0, 8);
            let croped2 = resp?.data?.splice(0, 8);
            croped?.map((itm) => {
              array1.push({
                totalLoad: itm?.count,
                address: itm?._id,
                date: itm?.origin_address,
              });
            });
            croped2?.map((itm) => {
              array.push({
                totalLoad: itm?.count,
                // address: itm?.origin_address,
                date: itm?.destination_address,
              });
            });
          }
        });
        // setFrequency(res?.data);
      }
      setMostInbound(array1);
      setMostBound(array);
    });
  };
  const MaxBounding = [
    ["Month", "Total Loads"],
    ...((MostBound?.length > 0 &&
      MostBound?.map((item) => {
        return [`${item?.date} `, item?.totalLoad];
      })) || [
        ["Element", "Density", { role: "style" }],
        ["Copper", 8.94, "#b87333"], // RGB value
        ["Silver", 10.49, "silver"], // English color name
        ["Gold", 19.3, "gold"],
        ["Platinum", 21.45, "color: #e5e4e2"], // CSS-style declaration
      ]),
  ];
  const MaxInboundArr = [
    ["Location", "Total Loads"],
    ...((MostInbound?.length > 0 &&
      MostInbound?.map((item) => {
        return [`${item?.date} `, item?.totalLoad];
      })) || [
        ["Element", "Density", { role: "style" }],
        ["Copper", 8.94, "#b87333"], // RGB value
        ["Silver", 10.49, "silver"], // English color name
        ["Gold", 19.3, "gold"],
        ["Platinum", 21.45, "color: #e5e4e2"], // CSS-style declaration
      ]),
  ];
  const LoadsByDistance = [
    ["Location", "Total Loads"],
    ...((maxDistance?.length > 0 &&
      maxDistance?.map((item) => {
        return [`${item?.date} `, item?.totalLoad];
      })) || [
        ["Element", "Density", { role: "style" }],
        ["Copper", 8.94, "#b87333"], // RGB value
        ["Silver", 10.49, "silver"], // English color name
        ["Gold", 19.3, "gold"],
        ["Platinum", 21.45, "color: #e5e4e2"], // CSS-style declaration
      ]),
  ];
  const GetDestination = (p) => {
    let array = [];
    let f = { ...filters, ...p };
    if (p?.board_id) {
      f = { ...filters, board_id: p?.board_id };
    }
    ApiClient.get("admin/dashboard/destination-volume", f).then((res) => {
      if (res.success) {
        // setFrequency(res?.data);
        let croped = res?.data?.splice(0, 8);
        croped?.map((itm) => {
          array.push({
            totalLoad: itm?.count,
            address: itm?.origin_address,
            date: `${itm?.destination_address}`,
          });
        });
      }

      setdestination(array);
    });
  };
  const GetLoadsByDistance = [
    ["Location", "Total Loads"],
    ...((destinations?.length > 0 &&
      destinations?.map((item) => {
        return [`${item?.date}`, item?.totalLoad];
      })) || [
        ["Element", "Density", { role: "style" }],
        ["Copper", 8.94, "#b87333"], // RGB value
        ["Silver", 10.49, "silver"], // English color name
        ["Gold", 19.3, "gold"],
        ["Platinum", 21.45, "color: #e5e4e2"], // CSS-style declaration
      ]),
  ];
  const GetMaxDistance = (p) => {
    let array = [];
    let f = { ...filters, ...p };
    if (p?.board_id) {
      f = { ...filters, board_id: p?.board_id };
    }

    ApiClient.get("admin/dashboard/lane-frequency/distance-analysis", f).then(
      (res) => {
        if (res.success) {
          setFrequency(res?.data);
          let croped = res?.data?.splice(0, 8);
          croped?.map((itm) => {
            array.push({
              totalLoad: itm?.count,
              address: itm?.origin_address,
              date: `${Math.round(itm?.max_distance)} Mi`,
            });
          });
        }

        setMaxdistance(array);
      }
    );
  };
  const GetPickUpHours = (p) => {
    let array = [];

    let f = { ...filters, ...p };
    if (p?.board_id) {
      f = { ...filters, board_id: p?.board_id };
    }

    ApiClient.get("admin/dashboard/peak-pickup-hours", f).then((res) => {
      if (res.success) {
        setFrequency(res?.data);
        let croped = res?.data?.splice(0, 10);
        croped?.map((itm) => {
          array.push({
            totalLoad: itm?.total,
            percentage: itm?.percentage,
            date: itm?.hour,
          });
        });
      }

      setPickUpHours(array);
    });
  };

  // const scansOverTimeOption = {
  //   colors: ["#42a2eb", "#4bc0bf"],
  //   annotations: {
  //     alwaysOutside: true,
  //   },
  //   legend: { position: "top" },
  //   vAxis: {
  //     format: "0", // Display integers only on the vertical axis
  //   },
  // };

  const scansOverTimeData = [
    ["Hours", "Total", "Percentage"],
    ...((PickUpHours?.length > 0 &&
      PickUpHours?.map((item) => {
        return [
          `${item?.date} ${item?.date > 12 || item?.date == 12 ? "PM" : "AM"}`,
          item?.totalLoad,
          Math.round(item?.percentage),
        ];
      })) || [
        ["Element", "Density", { role: "style" }],
        ["Copper", 8.94, "#b87333"], // RGB value
        ["Silver", 10.49, "silver"], // English color name
        ["Gold", 19.3, "gold"],
        ["Platinum", 21.45, "color: #e5e4e2"], // CSS-style declaration
      ]),
  ];

  const Getdeliveryoutside = (p) => {
    let array = [];
    let f = { ...filters, ...p };
    if (p?.board_id) {
      f = { ...filters, board_id: p?.board_id };
    }

    ApiClient.get("admin/dashboard/delivery/outside-business-hours", f).then(
      (res) => {
        if (res.success) {
          // setFrequency(res?.data);
          let croped = res?.data?.splice(0, 10);
          croped?.map((itm) => {
            array.push({
              totalLoad: itm?.total,
              percentage: itm?.percentage,
              date: itm?.hour,
            });
          });
        }

        SetDileveryOutside(array);
      }
    );
  };
  const scansOverTimeOptionDilevery = {
    colors: ["#42a2eb", "#4bc0bf"],
    annotations: {
      alwaysOutside: true,
    },
    legend: { position: "top" },
    vAxis: {
      format: "0", // Display integers only on the vertical axis
    },
  };
  const scansOverTimeDataDilevery = [
    ["Hour", "Percentage", "Total Loads"],
    ...((DileveryOutside?.length > 0 &&
      DileveryOutside?.map((item) => {
        return [
          `${item?.date} ${item?.date > 12 || item?.date == 12 ? "PM" : "AM"}`,
          Math.round(item?.percentage),
          item?.totalLoad,
        ];
      })) || [
        ["Element", "Density", { role: "style" }],
        ["Copper", 8.94, "#b87333"], // RGB value
        ["Silver", 10.49, "silver"], // English color name
        ["Gold", 19.3, "gold"],
        ["Platinum", 21.45, "color: #e5e4e2"], // CSS-style declaration
      ]),
  ];

  const GetPeakPickday = (p) => {
    let array = [];
    let f = { ...filters, ...p };
    if (p?.board_id) {
      f = { ...filters, board_id: p?.board_id };
    }


    ApiClient.get("admin/dashboard/peak-pickup-day", f).then((res) => {
      if (res.success) {
        // setFrequency(res?.data);
        let croped = res?.data?.splice(0, 10);
        croped?.map((itm) => {
          array.push({
            totalLoad: itm?.total,
            percentage: itm?.percentage,
            date: itm?.weekday,
          });
        });
      }

      setPeakPickDay(array);
    });
  };

  const PeackPickupDayOptions = {
    colors: ["#42a2eb", "#4bc0bf"],
    annotations: {
      alwaysOutside: true,
    },
    legend: { position: "top" },
    vAxis: {
      format: "0", // Display integers only on the vertical axis
    },
  };

  const PeackPickupDay = [
    ["Day", "Percentage", "Total Loads"],
    ...((PeakPickupDays?.length > 0 &&
      PeakPickupDays?.map((item) => {
        return [`${item?.date}`, Math.round(item?.percentage), item?.totalLoad];
      })) || [
        ["Element", "Density", { role: "style" }],
        ["Copper", 8.94, "#b87333"], // RGB value
        ["Silver", 10.49, "silver"], // English color name
        ["Gold", 19.3, "gold"],
        ["Platinum", 21.45, "color: #e5e4e2"], // CSS-style declaration
      ]),
  ];

  const GetPeakPostingHOurs = (p) => {
    let array = [];
    let f = { ...filters, ...p };
    if (p?.board_id) {
      f = { ...filters, board_id: p?.board_id };
    }


    ApiClient.get("admin/dashboard/peak-posting-hours", f).then((res) => {
      if (res.success) {
        // setFrequency(res?.data);
        let croped = res?.data?.splice(0, 10);
        croped?.map((itm) => {
          array.push({
            totalLoad: itm?.total,
            percentage: itm?.percentage,
            hour: itm?.hour,
          });
        });
      }

      setPeakPostingHour(array);
    });
  };

  // const PeackPostingHoursOptions = {
  //   colors: ["#42a2eb", "#4bc0bf"],
  //   annotations: {
  //     alwaysOutside: true,
  //   },
  //   legend: { position: "top" },
  //   vAxis: {
  //     format: "0", // Display integers only on the vertical axis
  //   },
  // };

  const PeackPostingHours = [
    ["Hours", "Percentage", "Total Loads"],
    ...((PeakPostingHour?.length > 0 &&
      PeakPostingHour?.map((item) => {
        return [
          `${item?.hour} ${item?.hour > 12 || item?.hour == 12 ? "PM" : "AM"}`,
          Number(Math.round(item?.percentage)),
          item?.totalLoad,
        ];
      })) || [
        ["Element", "Density", { role: "style" }],
        ["Copper", 8.94, "#b87333"], // RGB value
        ["Silver", 10.49, "silver"], // English color name
        ["Gold", 19.3, "gold"],
        ["Platinum", 21.45, "color: #e5e4e2"], // CSS-style declaration
      ]),
  ];

  const GetPeakPostingMonths = (p) => {
    let array = [];
    let f = { ...filters, ...p };
    if (p?.board_id) {
      f = { ...filters, board_id: p?.board_id };
    }


    ApiClient.get("admin/dashboard/peak-pickup-month", f).then((res) => {
      if (res.success) {
        // setFrequency(res?.data);
        let croped = res?.data?.splice(0, 10);
        croped?.map((itm) => {
          array.push({
            totalLoad: itm?.total,
            percentage: itm?.percentage,
            date: itm?.month,
          });
        });
      }

      setPeakPostingMonths(array);
    });
  };

  // const PeackPostingMonthsOptions = {
  //   colors: ["#42a2eb", "#4bc0bf"],
  //   annotations: {
  //     alwaysOutside: true,
  //   },
  //   legend: { position: "top" },
  //   vAxis: {
  //     format: "0", // Display integers only on the vertical axis
  //   },
  // };

  const GetMonths = (id) => {
    switch (id) {
      case 1:
        return "January";
        break;
      case 2:
        return "February";
        break;
      case 3:
        return "March";
        break;
      case 4:
        return "April";
        break;
      case 5:
        return "May";
        break;
      case 6:
        return "June";
        break;
      case 7:
        return "July";
        break;
      case 8:
        return "August";
        break;
      case 9:
        return "September";
        break;
      case 10:
        return "October";
        break;
      case 11:
        return "November";
        break;
      case 12:
        return "December";
    }
  };

  const PeackPostingMonths = [
    ["Month", "Percentage", "Total Loads"],
    ...((PeakPostingMonths?.length > 0 &&
      PeakPostingMonths?.map((item) => {
        return [GetMonths(item?.date), item?.percentage, item?.totalLoad];
      })) || [
        ["Element", "Density", { role: "style" }],
        ["Copper", 8.94, "#b87333"], // RGB value
        ["Silver", 10.49, "silver"], // English color name
        ["Gold", 19.3, "gold"],
        ["Platinum", 21.45, "color: #e5e4e2"], // CSS-style declaration
      ]),
  ];

  const [bidData, setbidData] = useState();

  // ---- Consolidated summary data for widget components ----
  const [summaryData, setSummaryData] = useState(null);
  const [dashboardLoading, setDashboardLoading] = useState(true);

  const getData = (p = {}) => {
    let f = { ...filters, ...p };
    if (p?.board_id) {
      f = { ...filters, board_id: p?.board_id };
    }
    setDashboardLoading(true);

    // Single consolidated API call replaces ~29 separate calls
    ApiClient.get("admin/dashboard/summary", f).then((res) => {
      if (res.success && res.data) {
        const d = res.data;
        setSummaryData(d);

        // --- Distribute data to existing state variables ---

        // Analytics (bid/load charts)
        if (d.analytics) {
          let totalBids = 0;
          let bidData = (d.analytics.BidsCounts?.response || []).map((itm) => {
            let month = `${datepipeModel.monthfind(itm.month - 1)}`;
            itm.date = `${month} ${itm.year}`;
            if (f.type == "daily") itm.date = `${itm.day} ${month}`;
            totalBids += itm.totalBidsCounts;
            return itm;
          });
          let totalLoads = 0;
          let ldata = (d.analytics.LoadsCounts?.response || []).map((itm) => {
            let month = `${datepipeModel.monthfind(itm.month - 1)}`;
            itm.date = `${month} ${itm.year}`;
            if (f.type == "daily") itm.date = `${itm.day} ${month}`;
            totalLoads += itm.totalBidsCounts || itm.totalLoadsCounts || 0;
            return itm;
          });
          setChartData({ totalBids, totalLoads });
          setBidChart(bidData);
          setLoadChart(ldata);
        }

        // Total Bids
        if (d.totalBids) setbidData({ success: true, ...d.totalBids });

        // Total Loads
        if (d.totalLoads) setLoadData({ success: true, ...d.totalLoads });

        // Total Load Board
        if (d.totalLoadBoard) setBoards(d.totalLoadBoard);

        // Lane Frequency (top 8)
        if (d.laneFrequency) {
          let array = [];
          (d.laneFrequency || []).slice(0, 8).forEach((itm) => {
            array.push({
              totalLoad: itm?.count,
              address: itm?.origin_address,
              date: `${itm?.origin_address} - ${itm?.destination_address}`,
            });
          });
          setData(array);
        }

        // Origins (top 8)
        if (d.originVolume) {
          let array = [];
          (d.originVolume || []).slice(0, 8).forEach((itm) => {
            array.push({ totalLoad: itm?.count, address: itm?.origin_address, date: itm?.origin_address });
          });
          setorigins(array);
          // Also set MostInbound
          let array1 = [];
          (d.originVolume || []).slice(0, 8).forEach((itm) => {
            array1.push({ totalLoad: itm?.count, address: itm?._id, date: itm?.origin_address });
          });
          setMostInbound(array1);
        }

        // Destinations (top 8)
        if (d.destinationVolume) {
          let array = [];
          (d.destinationVolume || []).slice(0, 8).forEach((itm) => {
            array.push({ totalLoad: itm?.count, address: itm?.origin_address, date: `${itm?.destination_address}` });
          });
          setdestination(array);
          // Also set MostBound
          let array2 = [];
          (d.destinationVolume || []).slice(0, 8).forEach((itm) => {
            array2.push({ totalLoad: itm?.count, date: itm?.destination_address });
          });
          setMostBound(array2);
        }

        // Distance Analysis (top 8)
        if (d.distanceAnalysis) {
          setFrequency(d.distanceAnalysis);
          let array = [];
          (d.distanceAnalysis || []).slice(0, 8).forEach((itm) => {
            array.push({ totalLoad: itm?.count, address: itm?.origin_address, date: `${Math.round(itm?.max_distance)} Mi` });
          });
          setMaxdistance(array);
        }

        // Peak Pickup Hours
        if (d.peakPickupHours) {
          let array = [];
          (d.peakPickupHours || []).slice(0, 10).forEach((itm) => {
            array.push({ totalLoad: itm?.total, percentage: itm?.percentage, date: itm?.hour });
          });
          setPickUpHours(array);
        }

        // Delivery Outside Business Hours
        if (d.deliveryOutsideBusinessHours) {
          let array = [];
          (d.deliveryOutsideBusinessHours || []).slice(0, 10).forEach((itm) => {
            array.push({ totalLoad: itm?.total, percentage: itm?.percentage, date: itm?.hour });
          });
          SetDileveryOutside(array);
        }

        // Peak Pickup Days
        if (d.peakPickupDays) {
          let array = [];
          (d.peakPickupDays || []).slice(0, 10).forEach((itm) => {
            array.push({ totalLoad: itm?.total, percentage: itm?.percentage, date: itm?.weekday });
          });
          setPeakPickDay(array);
        }

        // Peak Posting Hours
        if (d.peakPostingHours) {
          let array = [];
          (d.peakPostingHours || []).slice(0, 10).forEach((itm) => {
            array.push({ totalLoad: itm?.total, percentage: itm?.percentage, hour: itm?.hour });
          });
          setPeakPostingHour(array);
        }

        // Peak Pickup Months
        if (d.peakPickupMonths) {
          let array = [];
          (d.peakPickupMonths || []).slice(0, 10).forEach((itm) => {
            array.push({ totalLoad: itm?.total, percentage: itm?.percentage, date: itm?.month });
          });
          setPeakPostingMonths(array);
        }

        // Stop Total Time (top 8)
        if (d.stopTotalTime) {
          let array = [];
          (d.stopTotalTime || []).slice(0, 8).forEach((itm) => {
            array.push({ address: itm?.origin_address, totalLoad: itm?.count, avg_cost: itm?.avg_stop_parload, total_time: itm?.total_time });
          });
          setStopTotalTime(array);
        }

        // Delivery Hours (top 8)
        if (d.deliveryHours) {
          let array = [];
          (d.deliveryHours || []).slice(0, 8).forEach((itm) => {
            array.push({ address: itm?.origin_address, totalLoad: itm?.count, delivered_at: itm?.delivered_at });
          });
          setDileveyHour(array);
        }
      }
      setDashboardLoading(false);
    }).catch(() => {
      setDashboardLoading(false);
    });
  };

  const ChangeStatus = (key) => {
    getData({ ...filters, board_id: key?.id });
    setFilter({ ...filters, board_id: key?.id });
  };

  const getAnalytic = (p = {}) => {
    let f = { ...filters, ...p };
    // loader(true); // disabled - using consolidated endpoint
    ApiClient.get("analytics", f).then((res) => {
      if (res.success) {
        let totalBids = 0;

        let data = res.BidsCounts.response.map((itm) => {
          let month = `${datepipeModel.monthfind(itm.month - 1)}`;
          itm.date = `${month} ${itm.year}`;
          if (f.type == "daily") itm.date = `${itm.day} ${month}`;
          totalBids += itm.totalBidsCounts;
          return itm;
        });

        let totalLoads = 0;
        let ldata = res.LoadsCounts.response.map((itm) => {
          let month = `${datepipeModel.monthfind(itm.month - 1)}`;
          itm.date = `${month} ${itm.year}`;
          if (f.type == "daily") itm.date = `${itm.day} ${month}`;
          totalLoads += itm.totalBidsCounts;
          return itm;
        });

        setChartData({
          totalBids: totalBids,
          totalLoads: totalLoads,
        });

        setBidChart(data);
        setLoadChart(ldata);
      }
      // loader(false);
    });
  };

  // const GetStatistics = (f) => {
  //   let fltr = { ...filters, ...f };
  //   ApiClient.get("statistics/all-loads", fltr).then((res) => {
  //     if (res.success) {
  //       setStatistics(res?.data);
  //     }
  //   });
  // };

  const getTotalBids = (p) => {
    let f = { ...filters, ...p };
    ApiClient.get("total-bids", f).then((res) => {
      if (res.success) {
        setbidData(res);
      }
    });
  };

  const getTotalBoard = (p) => {
    let f = { ...filters, ...p };
    if (p?.board_id) {
      f = { ...filters, board_id: p?.board_id };
    }

    ApiClient.get("total-load/board", f).then((res) => {
      if (res.success) {
        setBoards(res.data);
      }
    });
  };

  const filter = (p = {}) => {
    setFilter({ ...filters, ...p });
    getData(p);
  };

  const onRangeChange = (e) => {
    let f = {
      startDate: datepipeModel.datetostring(e.startDate),
      endDate: datepipeModel.datetostring(e.endDate),
      compare: e.compare,
      compareStart: e.compareStart,
      compareEnd: e.compareEnd,
      type: e.type,
    };
    if (
      datepipeModel.datetostring(e.startDate) ==
      datepipeModel.datetostring(e.endDate)
    ) {
      setFilter({ ...filters, ...f });
    } else {
      filter({ ...f });
    }
  };
  useEffect(() => {
    if (user && user?.id) {
      getData();
      GetBoards();
    }
    // GetAverageCost();
  }, [user]);

  return (
    <Layout2 title="Dashboard" searchShow="false">
      <div className="mainareas new-dashboard">
        <div className="row d-flex align-items-center">
          <div className="col-md-9 head_cls">
            <h2 className="mb-1 mainHeading_cls">
              {" "}
              <span className="dsh_hedding">Hi</span>
              {user && methodModel.capitalizeFirstLetter(user?.fullName)}
            </h2>
            <p className="paraCls">
              Here’s what’s going on with your team One Brokerage
            </p>
          </div>
          <div>
            <div className="d-flex justify-content-sm-end flex-wrap align-items-center">
              <div className="dropdown addDropdown mt-0 mb-2 mb-sm-0 me-2">
                <button
                  className="btn btn-primary dropdown-toggle mb-0"
                  type="button"
                  id="dropdownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {Filtername
                    ? Filtername == ""
                      ? "All"
                      : methodModel.capitalizeFirstLetter(Filtername)
                    : "All"}
                </button>
                <div
                  className="dropdown-menu shadow bg_hover"
                  aria-labelledby="dropdownMenuButton"
                >
                  <a
                    className={
                      Filtername == ""
                        ? "dropdown-item active"
                        : "dropdown-item"
                    }
                    onClick={() => {
                      ChangeStatus("");
                      setFIltername("All");
                    }}
                  >
                    All
                  </a>
                  {Board &&
                    Board?.map((itm) => {
                      return (
                        <a
                          className={
                            filters?.board_id == itm?.id
                              ? "dropdown-item active"
                              : "dropdown-item"
                          }
                          onClick={() => {
                            ChangeStatus(itm);
                            setFIltername(itm?.name);
                          }}
                        >
                          {methodModel.capitalizeFirstLetter(itm?.name)}
                        </a>
                      );
                    })}
                </div>
              </div>
              <DateRangePicker
                value={{
                  startDate: filters.startDate,
                  endDate: filters.endDate,
                  compare: filters.compare,
                  compareStart: filters.compareStart,
                  compareEnd: filters.compareEnd,
                }}
                onChange={(e) => onRangeChange(e)}
                fullWidth={false}
              />
            </div>
          </div>
          <div className="cards_sales">
            <div className="row">
              {/* <div className="col-12 col-sm-12 col-md-6 col-lg-3 mt-3">
              <div className="sales_section">
                <div className="main_sales">
                  <div className="sales_headings">
                    <div>
                      <p className="sub_heading">Total Bids</p>
                    </div>
                    <div>
                      <img src="/assets/img/bag.png" className="wallets_img" />
                    </div>
                  </div>
                  <div className="sales_icons">
                    <h3 className="Amount_sales">{bidData?.total_bids}</h3>
                  </div>
                </div>
              </div>
            </div> */}
              <div className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 my-3">
                <div className="sales_section">
                  <Tooltip placement="top" title={`${Permission?.bid_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                    <div
                      className="main_sales pointer"
                      onClick={() => {
                        if (Permission?.bid_get || user?.role == "admin") {
                          localStorage.setItem("BidStatus", "awarded");
                          Navigate.push(`/awarded-bids?startDate=${filters.startDate}&endDate=${filters.endDate}`);
                        }

                      }}
                    >
                      <div className="das-box">
                        <div className="sales_headings">
                          <p className="sub_heading">Total Awarded Bids</p>
                          <div className="sales_icons">
                            <h3 className="Amount_sales">
                              {dashboardLoading ? <span className="placeholder-glow"><span className="placeholder col-6"></span></span> : (bidData?.awarded_bids || 0)}
                            </h3>
                          </div>
                        </div>
                        <div className="dash-img">
                          <img
                            src="/assets/img/awarded_one.svg"
                            className="wallets_img"
                          />
                        </div>
                      </div>
                    </div>
                  </Tooltip>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 my-3">
                <div className="sales_section">
                  <Tooltip placement="top" title={`${Permission?.bid_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                    <div
                      className="main_sales pointer"
                      onClick={() => {
                        if (Permission?.bid_get || user?.role == "admin") {
                          localStorage.setItem("BidStatus", "accepted");
                          Navigate.push(`/accepted-bids?startDate=${filters.startDate}&endDate=${filters.endDate}`);
                        }

                      }}
                    >

                      <div className="das-box">
                        <div className="sales_headings">
                          <p className="sub_heading">Total Accepted Bids</p>
                          <div className="sales_icons">
                            <h3 className="Amount_sales">
                              {dashboardLoading ? <span className="placeholder-glow"><span className="placeholder col-6"></span></span> : (bidData?.accepted_bids || 0)}
                            </h3>
                          </div>
                        </div>
                        <div className="dash-img">
                          <img
                            src="/assets/img/accepted_one.svg"
                            className="wallets_img"
                          />
                        </div>
                      </div>
                    </div>
                  </Tooltip>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 my-3">
                <div className="sales_section">
                  <Tooltip placement="top" title={`${Permission?.bid_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                    <div
                      className="main_sales pointer"
                      onClick={() => {
                        if (Permission?.bid_get || user?.role == "admin") {
                          localStorage.setItem("BidStatus", "rejected");
                          Navigate.push(`/rejected-bids?startDate=${filters.startDate}&endDate=${filters.endDate}`);
                        }

                      }}
                    >

                      <div className="das-box">
                        <div className="sales_headings">
                          <p className="sub_heading">Total Rejected Bids</p>
                          <div className="sales_icons">
                            <h3 className="Amount_sales">
                              {dashboardLoading ? <span className="placeholder-glow"><span className="placeholder col-6"></span></span> : (bidData?.rejected_bids || 0)}
                            </h3>
                          </div>
                        </div>
                        <div className="dash-img">
                          <img
                            src="/assets/img/rejected_one.svg"
                            className="wallets_img"
                          />
                        </div>
                      </div>
                    </div>
                  </Tooltip>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 my-3">
                <div className="sales_section">
                  <Tooltip placement="top" title={`${Permission?.bid_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                    <div
                      className="main_sales pointer"
                      onClick={() => {
                        if (Permission?.bid_get || user?.role == "admin") {
                          localStorage.setItem("BidStatus", "pending");
                          Navigate.push(`/pending-bids?startDate=${filters.startDate}&endDate=${filters.endDate}`);
                        }

                      }}
                    >
                      <div className="das-box">
                        <div className="sales_headings">
                          <p className="sub_heading">Total Pending Bids</p>
                          <div className="sales_icons">
                            <h3 className="Amount_sales">
                              {dashboardLoading ? <span className="placeholder-glow"><span className="placeholder col-6"></span></span> : (bidData?.pending_bids || 0)}
                            </h3>
                          </div>
                        </div>
                        <div className="dash-img">
                          <img
                            src="/assets/img/pending_one.svg"
                            className="wallets_img"
                          />
                        </div>
                      </div>

                    </div>
                  </Tooltip>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 my-3">
                <div className="sales_section">
                  <Tooltip placement="top" title={`${Permission?.load_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                    <div
                      className="main_sales pointer"
                      onClick={() => {
                        // localStorage.setItem("tabs", "pending-pickup");
                        if (Permission?.load_get || user?.role == "admin") {
                          Navigate.push("/pickedUp-loads");
                        }

                      }}
                    >

                      <div className="das-box">
                        <div className="sales_headings">
                          <p className="sub_heading">Total Pickedup Loads</p>
                          <div className="sales_icons">
                            <h3 className="Amount_sales">
                              {dashboardLoading ? <span className="placeholder-glow"><span className="placeholder col-6"></span></span> : (LoadsData?.pickedup_loads || 0)}
                            </h3>
                          </div>
                        </div>
                        <div className="dash-img">
                          <img
                            src="/assets/img/picked.svg"
                            className="wallets_img"
                          />
                        </div>
                      </div>


                    </div>
                  </Tooltip>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 my-3">
                <div className="sales_section">
                  <Tooltip placement="top" title={`${Permission?.load_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                    <div
                      className="main_sales pointer"
                      onClick={() => {
                        if (Permission?.load_get || user?.role == "admin") {
                          Navigate.push("/loads");
                        }

                      }}
                    >

                      <div className="das-box">
                        <div className="sales_headings">
                          <p className="sub_heading">Total Loads</p>
                          <div className="sales_icons">
                            <h3 className="Amount_sales">
                              {dashboardLoading ? <span className="placeholder-glow"><span className="placeholder col-6"></span></span> : (LoadsData?.total_loads || 0)}
                            </h3>
                          </div>
                        </div>
                        <div className="dash-img">
                          <img
                            src="/assets/img/loads.svg"
                            className="wallets_img"
                          />
                        </div>
                      </div>

                    </div>
                  </Tooltip>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 my-3">
                <div className="sales_section">
                  <Tooltip placement="top" title={`${Permission?.load_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                    <div
                      className="main_sales pointer"
                      onClick={() => {
                        // localStorage.setItem("ShipmentStatus", "pending");
                        if (Permission?.load_get || user?.role == "admin") {
                          Navigate.push("/loads");
                        }

                      }}
                    >

                      <div className="das-box">
                        <div className="sales_headings">
                          <p className="sub_heading">Total Pending Loads</p>
                          <div className="sales_icons">
                            <h3 className="Amount_sales">
                              {dashboardLoading ? <span className="placeholder-glow"><span className="placeholder col-6"></span></span> : (LoadsData?.pending_loads || 0)}
                            </h3>
                          </div>
                        </div>
                        <div className="dash-img">
                          <img
                            src="/assets/img/pending_one.svg"
                            className="wallets_img"
                          />
                        </div>
                      </div>
                    </div>
                  </Tooltip>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 my-3">
                <div className="sales_section">
                  <Tooltip placement="top" title={`${Permission?.load_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                    <div
                      className="main_sales pointer"
                      onClick={() => {
                        if (Permission?.load_get || user?.role == "admin") {
                          localStorage.setItem("ShipmentStatus", "delivered");
                          Navigate.push("/delivered-loads");
                        }

                      }}
                    >

                      <div className="das-box">
                        <div className="sales_headings">
                          <p className="sub_heading">Total Delivered Loads</p>
                          <div className="sales_icons">
                            <h3 className="Amount_sales">
                              {dashboardLoading ? <span className="placeholder-glow"><span className="placeholder col-6"></span></span> : (LoadsData?.delivered_loads || 0)}
                            </h3>
                          </div>
                        </div>
                        <div className="dash-img">
                          <img
                            src="/assets/img/delivered.svg"
                            className="wallets_img"
                          />
                        </div>
                      </div>



                    </div>
                  </Tooltip>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-3 my-3">
                <div className="sales_section">
                  <Tooltip placement="top" title={`${Permission?.load_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                    <div
                      className="main_sales pointer"
                      onClick={() => {
                        if (Permission?.load_get || user?.role == "admin") {
                          localStorage.setItem("ShipmentStatus", "in_transit");
                          Navigate.push("/intransit-loads");
                        }

                      }}
                    >
                      <div className="das-box">
                        <div className="sales_headings">
                          <p className="sub_heading">Total In-Transit Loads</p>
                          <div className="sales_icons">
                            <h3 className="Amount_sales">
                              {dashboardLoading ? <span className="placeholder-glow"><span className="placeholder col-6"></span></span> : (LoadsData?.intransit_loads || 0)}
                            </h3>
                          </div>
                        </div>
                        <div className="dash-img">
                          <img
                            src="/assets/img/transit.svg"
                            className="wallets_img"
                          />
                        </div>
                      </div>
                    </div>
                  </Tooltip>
                </div>
              </div>
            </div>

            {/* Fleet Overview Widget */}
            <div className="row">
              <div className="col-md-12 mb-4">
                <FleetOverview />
              </div>
            </div>

            {/* Dashboard KPI Widgets */}
            <div className="row mb-4">
              <div className="col-md-6 mb-3">
                {summaryData && <FinancialMetrics board_id={Filtername} dateRange={filters} summaryData={summaryData} />}
              </div>
              <div className="col-md-6 mb-3">
                {summaryData && <TodayOperations board_id={Filtername} summaryData={summaryData} />}
              </div>
            </div>
            <div className="row mb-4">
              <div className="col-md-6 mb-3">
                {summaryData && <PerformanceMetrics board_id={Filtername} dateRange={filters} summaryData={summaryData} />}
              </div>
              <div className="col-md-6 mb-3">
                {summaryData && <GrowthMetrics board_id={Filtername} dateRange={filters} summaryData={summaryData} />}
              </div>
            </div>

            {/* graph Design */}

            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 cls">
                <div className="graph_section">
                  <div className="graph_range mb-0">
                    <div>
                      <h3 className="Amount_sales">Bids</h3>
                    </div>

                    <div>
                      <Tooltip placement="top" title={`${Permission?.bid_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                        <p
                          className="view_graph"
                          onClick={(e) => {
                            if (Permission?.bid_get || user?.role == "admin") {
                              Navigate.push(`/bids`)
                            }
                          }

                          }
                        >
                          View Bids
                          <span className="arrowss">
                            <i class="material-icons">keyboard_arrow_right</i>
                          </span>
                        </p>
                      </Tooltip>
                    </div>
                  </div>

                  <div className="p-2 ">
                    <AllChart
                      data={bidChart}
                      legends={[
                        { label: "Total Bids", key: "totalBidsCounts" },
                      ]}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 cls">
                <div className="graph_section">
                  <div className="graph_range mb-0">
                    <div>
                      <h3 className="Amount_sales">Loads</h3>
                    </div>

                    <div>
                      <Tooltip placement="top" title={`${Permission?.load_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                        <p
                          className="view_graph"
                          onClick={(e) => {
                            if (Permission?.load_get || user?.role == "admin") {
                              Navigate.push(`/loads`)
                            }
                          }

                          }
                        >
                          View Loads
                          <span className="arrowss">
                            <i class="material-icons">keyboard_arrow_right</i>
                          </span>
                        </p>
                      </Tooltip>
                    </div>
                  </div>

                  <div className={`${ChartData?.length > 0 ? "" : "height-center"} p-2 `}>
                    {ChartData?.length > 0 ? <Chart
                      chartType="ColumnChart"
                      width="100%"
                      height="300px"
                      data={BidsByChartData}
                      options={{
                        colors: ["#42a2eb", "#4bc0bf"],
                        annotations: {
                          alwaysOutside: true,
                        },
                        legend: { position: "top" },
                        vAxis: {
                          format: "0", // Display integers only on the vertical axis
                        },
                      }} //
                    /> : <div className="text-center no-data">No Data</div>}

                  </div>



                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 cls mt-2">
                <div className="graph_section">
                  <div className="graph_range mb-0">
                    <div>
                      <h3 className="Amount_sales">Loads By Origin</h3>
                    </div>

                    <div>
                      <Tooltip placement="top" title={`${Permission?.load_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                        <p
                          className="view_graph"
                          onClick={(e) => {
                            {
                              if (Permission?.load_get || user?.role == "admin") {
                                Navigate.push(`/loads`)
                              }
                            }
                          }}
                        >
                          View Loads
                          <span className="arrowss">
                            <i class="material-icons">keyboard_arrow_right</i>
                          </span>
                        </p>
                      </Tooltip>
                    </div>
                  </div>

                  <div className={`${origins?.length > 0 ? "" : "height-center"} p-2`}>
                    {origins?.length > 0 ? (
                      <Chart
                        chartType="PieChart"
                        width="100%"
                        height="350px"
                        data={GetOirignBids}
                        options={{ pieSliceText: "none" }}
                        chartEvents={[
                          {
                            eventName: "select",
                            callback: ({ chartWrapper }) => {
                              const chart = chartWrapper.getChart();
                              const selection = chart.getSelection();

                              if (selection.length > 0) {
                                if (Permission?.load_get || user?.role === "admin") {
                                  setorigins((prev) => {
                                    let origin = prev?.[selection[0]?.row]?.date;

                                    setFilter((prevFilters) => {
                                      if (!prevFilters) return {}; // Ensure prevFilters is never undefined

                                      const updatedFilters = { ...prevFilters };
                                      console.log("Previous Filters:", prevFilters);
                                      console.log("Updated Filters:", updatedFilters);

                                      // Navigate after updating filters
                                      Navigate.push(
                                        `/loads?origin=${encodeURIComponent(origin)}&startDate=${updatedFilters.startDate}&endDate=${updatedFilters.endDate}`
                                      );

                                      return updatedFilters; // Ensure proper state update
                                    });

                                    return prev; // Keep previous origins state unchanged
                                  });
                                }
                              }
                            },
                          },
                        ]}
                      />
                    ) : (
                      <div className="text-center">No Data</div>
                    )}
                  </div>;

                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 cls mt-2">
                <div className="graph_section">
                  <div className="graph_range mb-0">
                    <div>
                      <h3 className="Amount_sales">Loads By Destinations</h3>
                    </div>

                    <div>
                      <Tooltip placement="top" title={`${Permission?.load_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                        <p
                          className="view_graph"
                          onClick={(e) => {
                            {
                              if (Permission?.load_get || user?.role == "admin") {
                                Navigate.push(`/loads`)
                              }
                            }
                          }}
                        >
                          View Loads
                          <span className="arrowss">
                            <i class="material-icons">keyboard_arrow_right</i>
                          </span>
                        </p>
                      </Tooltip>
                    </div>
                  </div>

                  <div className={`${destinations?.length > 0 ? "" : "height-center"} p-2`}>
                    {destinations?.length > 0 ? <Chart
                      chartType="ColumnChart"
                      width="100%"
                      height="300px"
                      data={GetLoadsByDistance}
                      options={{
                        colors: ["#42a2eb", "#4bc0bf"],
                        annotations: {
                          alwaysOutside: true,
                        },
                        legend: { position: "top" },
                        vAxis: {
                          format: "0",
                        },
                      }}
                      chartEvents={[
                        {
                          eventName: "select",
                          callback: ({ chartWrapper }) => {
                            const chart = chartWrapper.getChart();
                            const selection = chart.getSelection();
                            if (selection.length > 0) {
                              if (Permission?.load_get || user?.role === "admin") {
                                setdestination((prev) => {
                                  let destination = prev?.[selection[0]?.row]?.date;

                                  setFilter((prevFilters) => {
                                    if (!prevFilters) return {};

                                    const updatedFilters = { ...prevFilters };
                                    Navigate.push(
                                      `/loads?destination=${encodeURIComponent(destination)}&startDate=${updatedFilters.startDate}&endDate=${updatedFilters.endDate}`
                                    );

                                    return updatedFilters;
                                  });

                                  return prev;
                                });
                              }
                            }
                          }
                        },
                      ]}
                    /> : <div className="text-center">No Data</div>}

                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 cls mt-2">
                <div className="graph_section">
                  <div className="graph_range mb-0">
                    <div>
                      <h3 className="Amount_sales">Peak Pickup Hours</h3>
                    </div>

                    <div>
                      <Tooltip placement="top" title={`${Permission?.load_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                        <p
                          className="view_graph"
                          onClick={(e) => {
                            {
                              if (Permission?.load_get || user?.role == "admin") {
                                Navigate.push(`/loads`)
                              }
                            }
                          }}
                        >
                          View Loads
                          <span className="arrowss">
                            <i class="material-icons">keyboard_arrow_right</i>
                          </span>
                        </p>
                      </Tooltip>
                    </div>
                  </div>

                  <div className={`${PickUpHours?.length > 0 ? "" : "height-center"} p-2`}>
                    {PickUpHours?.length > 0 ? <Chart
                      chartType="PieChart"
                      width="100%"
                      height="350px"
                      data={scansOverTimeData}
                    // options={scansOverTimeOption} //
                    /> : <div className="text-center">No Data</div>}

                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 cls mt-2">
                <div className="graph_section">
                  <div className="graph_range mb-0">
                    <div>
                      <h3 className="Amount_sales">Peak Pickup Days Of Week</h3>
                    </div>

                    <div>
                      <Tooltip placement="top" title={`${Permission?.load_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                        <p
                          className="view_graph"
                          onClick={(e) => {
                            {
                              if (Permission?.load_get || user?.role == "admin") {
                                Navigate.push(`/loads`)
                              }
                            }
                          }}
                        >
                          View Loads
                          <span className="arrowss">
                            <i class="material-icons">keyboard_arrow_right</i>
                          </span>
                        </p>
                      </Tooltip>
                    </div>
                  </div>

                  <div className={`${PeakPickupDays?.length > 0 ? "" : "height-center"} p-2`}>
                    {PeakPickupDays?.length > 0 ? <Chart
                      chartType="ColumnChart"
                      width="100%"
                      height="350px"
                      data={PeackPickupDay}
                      options={PeackPickupDayOptions} //
                    /> : <div className="text-center">No Data</div>}

                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 cls mt-2">
                <div className="graph_section">
                  <div className="graph_range mb-0">
                    <div>
                      <h3 className="Amount_sales">Peak Posting Hours</h3>
                    </div>

                    <div>
                      <Tooltip placement="top" title={`${Permission?.load_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                        <p
                          className="view_graph"
                          onClick={(e) => {
                            {
                              if (Permission?.load_get || user?.role == "admin") {
                                Navigate.push(`/loads`)
                              }
                            }
                          }}
                        >
                          View Loads
                          <span className="arrowss">
                            <i class="material-icons">keyboard_arrow_right</i>
                          </span>
                        </p>
                      </Tooltip>
                    </div>
                  </div>

                  <div className={`${PeakPostingHour?.length > 0 ? "" : "height-center"} p-2`}>
                    {PeakPostingHour?.length > 0 ? <Chart
                      chartType="ColumnChart"
                      width="100%"
                      height="350px"
                      data={PeackPostingHours}
                      options={{

                        legend: { position: "top" },

                      }}
                    /> : <div className="text-center">No Data</div>}

                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 cls mt-2">
                <div className="graph_section">
                  <div className="graph_range mb-0">
                    <div>
                      <h3 className="Amount_sales">Peak Pickup Months</h3>
                    </div>

                    <div>
                      <Tooltip placement="top" title={`${Permission?.load_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                        <p
                          className="view_graph"
                          onClick={(e) => {
                            {
                              if (Permission?.load_get || user?.role == "admin") {
                                Navigate.push(`/loads`)
                              }
                            }
                          }}
                        >
                          View Loads
                          <span className="arrowss">
                            <i class="material-icons">keyboard_arrow_right</i>
                          </span>
                        </p>
                      </Tooltip>
                    </div>
                  </div>

                  <div className={`${PeakPostingMonths?.length > 0 ? "" : "height-center"} p-2`}>
                    {PeakPostingMonths?.length > 0 ? <Chart
                      chartType="ColumnChart"
                      width="100%"
                      height="350px"
                      data={PeackPostingMonths}
                      options={{
                        colors: ["#42a2eb", "#4bc0bf"],
                        annotations: {
                          alwaysOutside: true,
                        },
                        legend: { position: "top" },
                        vAxis: {
                          format: "0", // Display integers only on the vertical axis
                        },
                      }} //
                    /> : <div className="text-center">No Data</div>}

                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 cls mt-2">
                <div className="graph_section">
                  <div className="graph_range mb-0">
                    <div>
                      <h3 className="Amount_sales">
                        Delivery Outside Business Hours
                      </h3>
                    </div>

                    <div>
                      <Tooltip placement="top" title={`${Permission?.load_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                        <p
                          className="view_graph"
                          onClick={(e) => {
                            {
                              if (Permission?.load_get || user?.role == "admin") {
                                Navigate.push(`/loads`)
                              }
                            }
                          }}
                        >
                          View Loads
                          <span className="arrowss">
                            <i class="material-icons">keyboard_arrow_right</i>
                          </span>
                        </p>
                      </Tooltip>
                    </div>
                  </div>

                  <div className={`${DileveryOutside?.length > 0 ? "" : "height-center"} p-2`}>
                    {DileveryOutside?.length > 0 ? <Chart
                      chartType="ColumnChart"
                      width="100%"
                      height="350px"
                      data={scansOverTimeDataDilevery}
                      options={scansOverTimeOptionDilevery} //
                    /> : <div className="text-center">No Data</div>}

                  </div>
                </div>
              </div>

              <div className="col-12 col-sm-12 col-md-12 col-lg-6 cls mt-2">
                <div className="graph_section">
                  <div className="graph_range mb-0">
                    <div>
                      <h3 className="Amount_sales">Most Outbound Locations</h3>
                    </div>

                    <div>
                      <Tooltip placement="top" title={`${Permission?.load_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                        <p
                          className="view_graph"
                          onClick={(e) => {
                            {
                              if (Permission?.load_get || user?.role == "admin") {
                                Navigate.push(`/loads`)
                              }
                            }
                          }}
                        >
                          View Loads
                          <span className="arrowss">
                            <i class="material-icons">keyboard_arrow_right</i>
                          </span>
                        </p>
                      </Tooltip>
                    </div>
                  </div>

                  <div className={`${MostInbound?.length > 0 ? "" : "height-center"} p-2`}>
                    {MostBound?.length > 0 ? <Chart
                      chartType="ColumnChart"
                      width="100%"
                      height="350px"
                      data={MaxBounding}
                      options={{
                        colors: ["#42a2eb", "#4bc0bf"],
                        annotations: {
                          alwaysOutside: true,
                        },
                        legend: { position: "top" },
                        vAxis: {
                          format: "0", // Display integers only on the vertical axis
                        },
                      }} //
                    /> : <div className="text-center">No Data</div>}

                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 cls mt-2">
                <div className="graph_section">
                  <div className="graph_range mb-0">
                    <div>
                      <h3 className="Amount_sales">Most Inbound Locations</h3>
                    </div>

                    <div>
                      <Tooltip placement="top" title={`${Permission?.load_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                        <p
                          className="view_graph"
                          onClick={(e) => {
                            {
                              if (Permission?.load_get || user?.role == "admin") {
                                Navigate.push(`/loads`)
                              }
                            }
                          }}
                        >
                          View Loads
                          <span className="arrowss">
                            <i class="material-icons">keyboard_arrow_right</i>
                          </span>
                        </p>
                      </Tooltip>
                    </div>
                  </div>

                  <div className={`${MostInbound?.length > 0 ? "" : "height-center"} p-2`}>
                    {MostInbound?.length > 0 ? <Chart
                      chartType="ColumnChart"
                      width="100%"
                      height="350px"
                      data={MaxInboundArr}
                      options={{
                        colors: ["#42a2eb", "#4bc0bf"],
                        annotations: {
                          alwaysOutside: true,
                        },
                        legend: { position: "top" },
                        vAxis: {
                          format: "0", // Display integers only on the vertical axis
                        },
                      }} //
                    /> : <div className="text-center">No Data</div>}

                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 cls mt-2">
                <div className="graph_section">
                  <div className="graph_range mb-0">
                    <div>
                      <h3 className="Amount_sales">Loads By Max Distance</h3>
                    </div>

                    <div>
                      <Tooltip placement="top" title={`${Permission?.load_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                        <p
                          className="view_graph"
                          onClick={(e) => {
                            {
                              if (Permission?.load_get || user?.role == "admin") {
                                Navigate.push(`/loads`)
                              }
                            }
                          }}
                        >
                          View Loads
                          <span className="arrowss">
                            <i class="material-icons">keyboard_arrow_right</i>
                          </span>
                        </p>
                      </Tooltip>
                    </div>
                  </div>

                  <div className={`${maxDistance?.length > 0 ? "" : "height-center"} p-2`}>
                    {maxDistance?.length > 0 ? <Chart
                      chartType="ColumnChart"
                      width="100%"
                      height="350px"
                      data={LoadsByDistance}
                      options={{
                        colors: ["#fc466b", "#4bc0bf"],
                        annotations: {
                          alwaysOutside: true,
                        },
                        legend: { position: "top" },
                        vAxis: {
                          format: "0", // Display integers only on the vertical axis
                        },
                      }} //
                    /> : <div className="text-center">No Data</div>}

                  </div>
                </div>
              </div>

              {/* <div className="col-12 col-sm-12 col-md-12 col-lg-6 cls mt-2">
              <div className="graph_section">
                <div className="graph_range mb-0">
                  <div>
                    <h3 className="Amount_sales">Loads by Average Cost</h3>
                  </div>

                  <div>
                    <p
                      className="view_graph"
                      onClick={(e) => Navigate.push(`/loads`)}
                    >
                      View Loads
                      <span className="arrowss">
                        <i class="material-icons">keyboard_arrow_right</i>
                      </span>
                    </p>
                  </div>
                </div>

                <div>

                  <Chart
                    chartType="ColumnChart"
                    width="100%"
                    height="350px"
                    data={GetAverage}
                    options={{
                      colors: ["#febf01", "#a5c956"],
                      annotations: {
                        alwaysOutside: true,
                      },
                      legend: { position: "top" },
                      vAxis: {
                        format: "0", // Display integers only on the vertical axis
                      },
                    }} //
                  />

                </div>
              </div>
            </div> */}
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 cls mt-2">
                <div className="graph_section">
                  <div className="graph_range mb-0">
                    <div>
                      <h3 className="Amount_sales">
                        Loads by Stops with Total Time
                      </h3>
                    </div>

                    <div>
                      <Tooltip placement="top" title={`${Permission?.load_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                        <p
                          className="view_graph"
                          onClick={(e) => {
                            {
                              if (Permission?.load_get || user?.role == "admin") {
                                Navigate.push(`/loads`)
                              }
                            }
                          }}
                        >
                          View Loads
                          <span className="arrowss">
                            <i class="material-icons">keyboard_arrow_right</i>
                          </span>
                        </p>
                      </Tooltip>
                    </div>
                  </div>

                  <div className={`${StopTotalTime?.length > 0 ? "" : "height-center"} p-2`}>
                    {
                      StopTotalTime?.length > 0 ? <Chart
                        chartType="ColumnChart"
                        width="100%"
                        height="350px"
                        data={StopsTotalTimes}
                        options={{
                          colors: ["#fc466b", "#4bc0bf"],
                          annotations: {
                            alwaysOutside: true,
                          },
                          legend: { position: "top" },
                          vAxis: {
                            format: "0", // Display integers only on the vertical axis
                          },
                        }} //
                      /> : <div className="text-center">No Data</div>
                    }

                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 cls mt-2">
                <div className="graph_section">
                  <div className="graph_range mb-0">
                    <div>
                      <h3 className="Amount_sales">
                        {" "}
                        Tops Loads by dilevery Time
                      </h3>
                    </div>

                    <div>
                      <Tooltip placement="top" title={`${Permission?.load_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                        <p
                          className="view_graph"
                          onClick={(e) => {
                            {
                              if (Permission?.load_get || user?.role == "admin") {
                                Navigate.push(`/loads`)
                              }
                            }
                          }}
                        >
                          View Loads
                          <span className="arrowss">
                            <i class="material-icons">keyboard_arrow_right</i>
                          </span>
                        </p>
                      </Tooltip>
                    </div>
                  </div>

                  <div className={`${DileveyHour?.length > 0 ? "" : "height-center"} p-2`}>
                    {DileveyHour?.length > 0 ? <Chart
                      chartType="ColumnChart"
                      width="100%"
                      height="300px"
                      data={DileveyHours}
                      options={{
                        colors: ["#42a2eb", "#4bc0bf"],
                        annotations: {
                          alwaysOutside: true,
                        },
                        legend: { position: "top" },
                        vAxis: {
                          format: "0", // Display integers only on the vertical axis
                        },
                      }} //
                    /> : <div className="text-center">No Data</div>}

                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-6 cls mt-2">
                <div className="graph_section">
                  <div className="graph_range mb-0">
                    <div>
                      <h3 className="Amount_sales">Loads</h3>
                    </div>

                    <div>
                      <Tooltip placement="top" title={`${Permission?.load_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                        <p
                          className="view_graph"
                          onClick={(e) => {
                            {
                              if (Permission?.load_get || user?.role == "admin") {
                                Navigate.push(`/loads`)
                              }
                            }
                          }}
                        >
                          View Loads
                          <span className="arrowss">
                            <i class="material-icons">keyboard_arrow_right</i>
                          </span>
                        </p>
                      </Tooltip>
                    </div>
                  </div>

                  <div className="p-2 ">
                    <AllChart
                      data={loadChart}
                      legends={[
                        { label: "Total Loads", key: "totalLoadsCounts" },
                      ]}
                    />
                  </div>
                </div>
              </div>
              {/* <div className="col-12 col-sm-12 col-md-12 col-lg-6 cls">
              <div className="graph_section">
                <div className="graph_range mb-0">
                  <div>
                    <h3 className="Amount_sales">Pickup by Hours</h3>
                  </div>

                  <div>
                    <p
                      className="view_graph"
                      onClick={(e) => Navigate.push(`/bids`)}
                    >
                      View Bids
                      <span className="arrowss">
                        <i class="material-icons">keyboard_arrow_right</i>
                      </span>
                    </p>
                  </div>
                </div>

                <div>

                  <Chart
                    chartType="PieChart"
                    width="100%"
                    height="350px"
                    data={scansOverTimeData}
                    // options={scansOverTimeOption} //
                  />
                </div>
              </div>
            </div> */}
              <div className="col-12 col-sm-12 mt-2">
                <div className="graph_section">
                  <div className="graph_range mb-0">
                    <div>
                      <h3 className="Amount_sales">Load Classification</h3>
                    </div>

                    <div>
                      <Tooltip placement="top" title={`${Permission?.board_get || user?.role == "admin" ? "" : `You don't have permission to access this section.`}`}>
                        <p
                          className="view_graph"
                          onClick={(e) => {
                            if (Permission?.board_get || user?.role == "admin") {
                              Navigate.push(`/boards`)
                            }
                          }}
                        >
                          View Load Classification
                          <span className="arrowss">
                            <i class="material-icons">keyboard_arrow_right</i>
                          </span>
                        </p>
                      </Tooltip>
                    </div>
                  </div>

                  <div className="revenue_graph">
                    {/* table */}

                    <div className="table-responsive table_section  add mt-0 p-0">
                      <table class="table ">
                        <tbody>
                          {boards.map((itm) => {
                            return (
                              <tr className="dashboard">
                                <td>
                                  <div className="shipment_section">
                                    <div className="orders">
                                      <div className="ship_items">
                                        <img
                                          src="/assets/img/Item.png"
                                          className="order_ship"
                                        />
                                      </div>
                                      <div>
                                        <h3 className="item_no text-capitalize">
                                          {itm.load_name}
                                        </h3>
                                        {/* <p className="item_name">{itm.load_name}</p> */}
                                      </div>
                                    </div>

                                    <div className="item_rate">
                                      <div>
                                        <h5 className="item_price">
                                          {itm.total_load}
                                        </h5>
                                        {/* <p className="shipment_time">
                                    Overdue 10 hours
                                  </p> */}
                                      </div>
                                    </div>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout2>
  );
};

export default Dashboard2;
